export default {
  'transactions.productTitle.OB': 'Open Browser',
  'transactions.productTitle.OBLite': 'Open Browser Lite',
  'transactions.productTitle.MP': 'Metax TV',
  'transactions.productTitle.OB1.0': 'Open Browser 1.0',
  'transactions.productTitle.DistributionOwn': 'Content Distribution',
  'transactions.productTitle.AdSdk': 'Ad SDK',
  'transactions.productTitle.DistributionThirdParty': 'Content Distribution Third-party',
  'transactions.productTitle.OTT': 'OTT App',
  'transactions.productTitle.MetaXSSP': 'MetaX SSP',

  'transactions.monthRange': 'Month Range',
  'transactions.selectProducts': 'Select products',
  'transactions.confirmedRevenue': 'Confirmed Revenue',
  'transactions.currency': 'Currency',
  'transactions.exchangeRate': 'Exchange Rate',
  'transactions.paymentRevenue': 'Payment Revenue',
  'transactions.financeCurrency': 'Finance Currency',
  'transactions.financeExchangeRate': 'Finance Exchange Rate',
  'transactions.deduction': 'Deduction',
  'transactions.deductionRemark': 'Description',
  'transactions.paymentStatus': 'Payment Status',
  'transactions.paid': 'Paid',
  'transactions.pending': 'Pending',
}
